import { render, staticRenderFns } from "./query.vue?vue&type=template&id=cd0fa3d6&scoped=true"
import script from "./query.vue?vue&type=script&lang=js"
export * from "./query.vue?vue&type=script&lang=js"
import style0 from "./query.vue?vue&type=style&index=0&id=cd0fa3d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0fa3d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd0fa3d6')) {
      api.createRecord('cd0fa3d6', component.options)
    } else {
      api.reload('cd0fa3d6', component.options)
    }
    module.hot.accept("./query.vue?vue&type=template&id=cd0fa3d6&scoped=true", function () {
      api.rerender('cd0fa3d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcDrugDosage/query.vue"
export default component.exports